<template>
  <InputComponent class="contract-template-upload" :label="label">
    <div class="contract-template-upload__disclaimer elder-input__element">
      <FileComponent v-if="valueComp || disclaimer" v-model="valueComp" accept=".pdf" v-bind="$attrs">
        <template #drop-message="{ extensions }">
          <span
            v-html="$t('dragFileOrDrop', { extension: `(${extensions.map(e => e.toUpperCase()).join(', ')})` })"
          ></span>
          <div class="contract-template-upload__help">
            <span>{{ $t('howToBuildContract') }}</span>
            <Tour :value="{ categories: ['Contract'] }" />
          </div>
        </template>
      </FileComponent>
      <div class="contract-template-upload__unconfirmed" v-else>
        <div class="g-1">
          <Icon icon="fa-pro-solid:arrow-down" />
          <span>{{ $t('contractTemplateUploadDisclaimerPointer') }}</span>
        </div>
        <div class="contract-template-upload__help">
          <span
            >{{ $t('howToBuildContract') }}
            <a v-if="sample" :href="sample" target="_blank">{{ $t('downloadSample') }}</a></span
          >
          <Tour :value="{ categories: ['Contract'] }" />
        </div>
      </div>
      <CheckboxComponent
        :value="Boolean(valueComp || disclaimer)"
        @input="setDisclaimer"
        :label="$t('contractTemplateUploadDisclaimer')"
      />
      <slot name="below" />
    </div>
  </InputComponent>
</template>

<script>
import { FileComponent } from '@kvass/file'
import { InputComponent } from 'vue-elder-input'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { CheckboxComponent } from 'vue-elder-checkbox'

export default {
  props: {
    value: Object,
    label: String,
    sample: String,
  },
  data() {
    return {
      disclaimer: false,
    }
  },
  computed: {
    valueComp: {
      get() {
        return this.value
      },
      set(val) {
        return this.$emit('input', val)
      },
    },
    company() {
      return this.$store.state.enums.ClientDetails.company
    },
  },
  methods: {
    setDisclaimer() {
      if (!this.disclaimer && !this.value) return (this.disclaimer = true)

      this.$emit('input', null)
      this.disclaimer = false
    },
  },
  components: {
    FileComponent,
    Alert,
    InputComponent,
    CheckboxComponent,
  },
}
</script>

<style lang="scss">
.contract-template-upload {
  &__disclaimer {
    padding: 0;
  }

  &__unconfirmed {
    padding: 1rem;
    display: flex;
    flex-direction: column;

    justify-content: space-between;
    background-color: var(--vue-elder-input-color, #f2f2f2);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    font-size: var(--font-size-small);

    & > div:first-child {
      padding: 0.55rem 0 0.1rem 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__help {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    text-align: left;
    font-size: var(--font-size-small);
    border-top: 1px solid var(--border-color);

    padding-top: 1rem;
    margin-top: 1.5rem;
  }

  .elder-checkbox {
    padding-top: 0.75rem;
    padding-left: 0.5rem;
  }

  .kvass-file__droparea {
    padding-bottom: 1rem;
  }

  .elder-input__field {
    border: none;
  }
}
</style>
